import React, {useState, useEffect} from "react"
import SaveButton from './utils/saveButton'
import TvModal from "./tvModal"
import ActorInfo from "./components/actorInfo"
import imdbLogo from "./assets/images/imdb.png"
import WatchInfo from "./components/watchInfo"

export default function TvCard( { show } ) {
    const [details, setDetails] = useState([])
    const [cast, setCast] = useState([])
    const [similars, setSimilars] = useState([])
    const [recommendations, setRecommendations] = useState([])
    const [externalIds, setExternalIDs] = useState([])
    const [seasons, setSeasons] = useState([])
    const allSeasons = []

    const TMDB_KEY = process.env.REACT_APP_TMDB_KEY || "";
 
    useEffect(() => {
        getDetails()    
    }, [])

    useEffect(() => {
        getCast()
    }, [])    

    useEffect(() => {
        getSimilars()
    }, [])

    useEffect(() => {
        getExternalIDs()
    }, [])

    useEffect(() => {
        getRecommendations()
    }, [])    

    useEffect(() => {
        getSeasons()
        // eslint-disable-next-line
    }, [details])    
    
    
    var dispDate = new Date(show.first_air_date)
    const getDetails = async () => {
        const url = `https://api.themoviedb.org/3/tv/${show.id}?api_key=${TMDB_KEY}&language=en-US`;
        const res = await fetch(url);
        const data  = await res.json(); 
        setDetails(data)


        for(var x=1; x<=details.number_of_seasons; x++) {
            const url = `https://api.themoviedb.org/3/tv/${show.id}/season/${x}?api_key=${TMDB_KEY}&language=en-US`
            const res = fetch(url);
            const data  = res.json();
            allSeasons.push(data)
        }
        setSeasons(allSeasons)
    }

    const getCast = async () => {
        //console.log(show.id);
        const url = `https://api.themoviedb.org/3/tv/${show.id}/credits?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setCast(data.cast)
    }

    const getSimilars = async () => {
        const url = `https://api.themoviedb.org/3/tv/${show.id}/similar?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setSimilars(data)
    }    

    const getRecommendations = async () => {
        const url = `https://api.themoviedb.org/3/tv/${show.id}/recommendations?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setRecommendations(data)
    }     

    const getExternalIDs = async () => {
        const url = `https://api.themoviedb.org/3/tv/${show.id}/external_ids?api_key=${TMDB_KEY}&language=en-US`
        const res = await fetch(url);
        const data  = await res.json(); 
        setExternalIDs(data)
        //console.log(data);     
    }

    const getSeasons = async () => {
        for(var x=1; x<=details.number_of_seasons; x++) {
            const url = `https://api.themoviedb.org/3/tv/${show.id}/season/${x}?api_key=${TMDB_KEY}&language=en-US`
            const res = await fetch(url);
            const data  = await res.json();
            allSeasons.push(data)
        }
        setSeasons(allSeasons)
    }

    if(Array.isArray(details.genres)) {
        details.genres.map(genre => genre.name) 
    }
    const style = {  
        backgroundImage: `url("https://image.tmdb.org/t/p/w1920_and_h800_multi_faces/${details.backdrop_path}")`,
        backgroundPosition: 'right top',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
    }
    
    const posterPath = details.poster_path || show.poster_path
    const leftStyle = {
        width: '100%',
        height: '201px',
        backgroundImage: posterPath ? `url("https://image.tmdb.org/t/p/w342${posterPath}")` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: '4px'
    }

    const rightStyle = {  
        width: posterPath ? '60%' : '40%',
        paddingLeft: '10px'
    }

    return (
         <div className="card">
            <table>
                <tbody>
                <tr>
                    <td width="20%" valign="top" className="poster">
                    </td>
                    <td>
                        <div className="card--content" key={show.id} style={{overflow: 'hidden'}}>
                            <h3 className="card--title">
                                {show.name} ({dispDate.getFullYear()})
                                <span style={{float:"right"}}>
                                    <SaveButton show={show} />
                                </span>
                            </h3>
                            <div style={{display:'flex'}}>
                                <div style={{width:'40%', float:'left', display:'flex', flexDirection:'column', alignItems:'center'}}>
                                    <div style={leftStyle} aria-hidden={!posterPath} />
                                    {externalIds && externalIds.imdb_id ? (
                                        <a href={`https://imdb.com/title/${externalIds.imdb_id}`} rel="noopener noreferrer" target="_blank" style={{marginTop:8}}>
                                            <img src={imdbLogo} className="imdb-logo" alt="IMDb" title="Go to IMDb" style={{width:60}} />
                                        </a>
                                    ) : null}
                                    <div style={{marginTop:8, display:'flex', justifyContent:'center'}}>
                                        <SaveButton show={show} />
                                    </div>
                                </div>
                            
                            <div className="" style={rightStyle}>
                                <div className="alert alert-info" style={{opacity: "0.8"}}>
                                    <div>
                                        <small><strong>AIR DATES:</strong> {show.first_air_date} to {details.last_air_date}</small>
                                    </div>
                                    <hr />
                                    <div>
                                        <small><strong>SEASONS:</strong> {details.number_of_seasons}<br />({details.number_of_episodes} episodes)</small>
                                    </div>
                                    <hr />                                
                                    <div>
                                        <small>
                                            <strong>GENRE(S):</strong>
                                            {Array.isArray(details.genres) ? details.genres.map(genre => (<li key={genre.id}>{genre.name}</li>)) : ""}
                                        </small>
                                    </div>
                                    <hr />
                                    <div>
                                        <small>
                                            <strong>RATING:</strong> {show.vote_average} out of 10
                                        </small>
                                    </div>
                                    <hr />
                                    <div>
                                        <small>
                                            <strong>ORIGINAL NETWORK(S):</strong>
                                        {Array.isArray(details.networks) ? details.networks.map(network => (<li key={network.id}>{network.name}</li>)) : ""}
                                        </small>
                                    </div>                                
                                </div>
                                </div>
                            </div>
                            <table className="table text-center">
                                <tbody>
                                <tr>
                                    <td width="25%">
                                        <a href={`https://imdb.com/title/${externalIds.imdb_id}`} rel="noopener noreferrer" target="_blank">
                                            <img src={imdbLogo} className="" style={{width:"80px"}} alt="IMDb" title="Go to IMDb" />
                                        </a>
                                    </td>

                                    {externalIds.facebook_id !== null
                                        ?   <td>
                                                <a href={`http://facebook.com/${externalIds.facebook_id}`} rel="noopener noreferrer" target="_blank">
                                                    <i className="ri-facebook-fill" style={{fontSize:"2.2rem"}}></i>
                                                </a>
                                            </td>
                                        :   null
                                    }

                                    {externalIds.twitter_id !== null
                                        ?   <td>
                                                <a href={`http://twitter.com/${externalIds.twitter_id}`} rel="noopener noreferrer" target="_blank">
                                                    <i className="ri-twitter-fill" style={{fontSize:"2.2rem"}}></i>
                                                </a>
                                            </td>
                                        :   null
                                    }
                                    {externalIds.instagram_id !== null
                                        ?   <td>
                                                <a href={`http://instagram.com/${externalIds.instagram_id}`} rel="noopener noreferrer" target="_blank">
                                                    <i className="ri-instagram-fill" style={{fontSize:"2.2rem"}}></i>
                                                </a>
                                            </td>
                                        :   null
                                    }
                            </tr>
                            </tbody>
                        </table>

                            <p className="card--desc" style={{marginTop:"20px"}}>{show.overview}</p>

                            <WatchInfo movie={show} source="tv" />

                            <ActorInfo cast={cast} />

                            <TvModal details={details} similars={similars} seasons={seasons} recommendations={recommendations} />
                        </div>
                    </td>
                </tr>
                </tbody>
            </table> 
        </div>
    )
}
